import {
    UPDATEWALLETOWNERSETTING_SUCCESS,
    UPDATEWALLETOWNERSETTING_FAILED,
    RESET_UPDATEWALLETOWNERSETTING,
    LOADING_UPDATEWALLETOWNERSETTING,
    NETWORK_ERROR_UPDATEWALLETOWNERSETTING,
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetUpdateWalletOwnerSettingDetails = () => {
    return { type: RESET_UPDATEWALLETOWNERSETTING };
};

const updateWalletOwnerSettingDetails = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_UPDATEWALLETOWNERSETTING });
    await adminServices
        .post("updateWalletOwnerSettingDetails", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(updateWalletOwnerSettingDetailssuccess(res.data));
                    break;
                default:
                    dispatch(updateWalletOwnerSettingDetailsFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({ type: NETWORK_ERROR_UPDATEWALLETOWNERSETTING, payload: err });
        });
};
function updateWalletOwnerSettingDetailssuccess(data) {
    return {
        type: UPDATEWALLETOWNERSETTING_SUCCESS,
        payload: data,
    };
}
function updateWalletOwnerSettingDetailsFailed(data) {
    return {
        type: UPDATEWALLETOWNERSETTING_FAILED,
        payload: data,
    };
}

export { resetUpdateWalletOwnerSettingDetails, updateWalletOwnerSettingDetails };
